import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-utility-router',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './utility-router.component.html',
  styleUrl: './utility-router.component.scss'
})
export class UtilityRouterComponent {

}
